import RecoverSeedPhraseTemp from "../templates/ImportWalletTemp/RecoverSeedPhraseTemp";

const RecoverSeedPhrase = () => <RecoverSeedPhraseTemp />;

export default RecoverSeedPhrase;